import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable, IsUUIDWithLVS, PromotionSubTypeEnum, PromotionTypeEnum, StoreItemValidityEnum, SupportedCurrencyEnum, } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsEnum, IsIn, IsInstance, IsNotEmpty, IsNumber, IsOptional, IsString, MaxLength, ValidateNested } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
import { ReadOrderDiscountCodeReferenceDto } from './ReadOrderDiscountCodeReferenceDto';
import { ReadOrderPromotionConditionDto } from './ReadOrderPromotionConditionDto';
import { ReadOrderPromotionDiscountDto } from './ReadOrderPromotionDiscountDto';
import { ReadOrderPromotionTargetElementDto } from './ReadOrderPromotionTargetElementDto';
export class ReadOrderPromotionDto {
}
__decorate([
    ApiProperty({ type: () => String, description: 'Promotion uuid', example: 'b22c590f-c4c4-4761-b528-8287e0ec3777' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsUUIDWithLVS('4'),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPromotionDto.prototype, "uuid", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Promotion title', example: '%5 off an item [req+opt mods]' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPromotionDto.prototype, "title", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Promotion subtitle', example: '%5 off an item [req+opt mods]' }),
    IsUndefinable({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPromotionDto.prototype, "subtitle", void 0);
__decorate([
    ApiProperty({ enum: PromotionTypeEnum, example: PromotionTypeEnum.PROMOTION }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(PromotionTypeEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPromotionDto.prototype, "type", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Promotion guid', example: 'TZKWNDGDWBMNMQQ7FBXFTS2D' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPromotionDto.prototype, "posGuid", void 0);
__decorate([
    ApiProperty({ enum: PromotionSubTypeEnum, example: PromotionSubTypeEnum.PROMOTION }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(PromotionSubTypeEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPromotionDto.prototype, "subtype", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'Promotion amount', example: 0.08 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadOrderPromotionDto.prototype, "amount", void 0);
__decorate([
    ApiProperty({ type: () => Number, description: 'Promotion percentage', example: 5.33 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadOrderPromotionDto.prototype, "percentage", void 0);
__decorate([
    ApiProperty({ enum: SupportedCurrencyEnum, example: SupportedCurrencyEnum.USD }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(SupportedCurrencyEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPromotionDto.prototype, "currency", void 0);
__decorate([
    ApiProperty({ type: ReadOrderPromotionDiscountDto }),
    Type(() => ReadOrderPromotionDiscountDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(ReadOrderPromotionDiscountDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", ReadOrderPromotionDiscountDto)
], ReadOrderPromotionDto.prototype, "discount", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadOrderDiscountCodeReferenceDto }),
    Type(() => ReadOrderDiscountCodeReferenceDto),
    IsOptional({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(ReadOrderDiscountCodeReferenceDto, { always: true }),
    ValidateNested({ always: true }),
    __metadata("design:type", ReadOrderDiscountCodeReferenceDto)
], ReadOrderPromotionDto.prototype, "discountCodeReference", void 0);
__decorate([
    ApiProperty({ type: ReadOrderPromotionConditionDto }),
    Type(() => ReadOrderPromotionConditionDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(ReadOrderPromotionConditionDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", ReadOrderPromotionConditionDto)
], ReadOrderPromotionDto.prototype, "conditions", void 0);
__decorate([
    ApiPropertyOptional({ type: ReadOrderPromotionTargetElementDto, isArray: true }),
    Type(() => ReadOrderPromotionTargetElementDto),
    IsUndefinable({ always: true }),
    IsArray({ always: true }),
    IsInstance(ReadOrderPromotionTargetElementDto, { always: true, each: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], ReadOrderPromotionDto.prototype, "elements", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 1 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], ReadOrderPromotionDto.prototype, "quantity", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Promotion image', example: 'https://*.jpg' }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPromotionDto.prototype, "image", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Object)
], ReadOrderPromotionDto.prototype, "loyaltyInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Promotion code', example: '1234' }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPromotionDto.prototype, "promoCode", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Promo code id', format: 'uuid' }),
    IsUndefinable({ always: true }),
    IsUUIDWithLVS('4'),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPromotionDto.prototype, "promoCodeUuid", void 0);
__decorate([
    ApiPropertyOptional({ enum: StoreItemValidityEnum, example: StoreItemValidityEnum.VALID }),
    IsUndefinable({ always: true }),
    IsEnum(StoreItemValidityEnum, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPromotionDto.prototype, "validity", void 0);
__decorate([
    ApiProperty({ enum: StoreItemValidityEnum, example: StoreItemValidityEnum.VALID }),
    IsIn(['FIRST_PARTY', 'THIRD_PARTY'], { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], ReadOrderPromotionDto.prototype, "implementedBy", void 0);
//# sourceMappingURL=ReadOrderPromotionDto.js.map